import * as tslib_1 from "tslib";
import { IdbService } from '@ml/core/services/idb.service';
import * as i0 from "@angular/core";
import * as i1 from "../../core/services/idb.service";
var TaskIDBService = /** @class */ (function () {
    function TaskIDBService(idbService) {
        this.idbService = idbService;
        if (!('indexedDB' in window)) {
            throw new Error('This browser does not support IndexedDB');
        }
    }
    TaskIDBService.prototype.getId = function () {
        return new Date().getTime();
    };
    TaskIDBService.prototype.idbContext = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.idbService.idbContext()];
            });
        });
    };
    /**
     * If the log is already created in the IndexedDB, then we'll update the end time
     * If the log is not added in the IndexedDB, we'll added in logs-stopped table
     */
    TaskIDBService.prototype.stopLog = function (log, body) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var db;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.idbContext()];
                    case 1:
                        db = _a.sent();
                        log.end = new Date();
                        log.extraInformation = body.extraInformation || '';
                        log.measurementUnits = body.measurementUnits || [];
                        if (!(log.idb && log.id)) return [3 /*break*/, 3];
                        return [4 /*yield*/, db.put(TaskIDBService.dbLogsTable, log, log.id)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: 
                    // Add the log as stopped log
                    return [4 /*yield*/, db.add(TaskIDBService.dbStopLogsTable, log, log.id)];
                    case 4:
                        // Add the log as stopped log
                        _a.sent();
                        _a.label = 5;
                    case 5: return [2 /*return*/, log];
                }
            });
        });
    };
    TaskIDBService.prototype.saveLog = function (log) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var db, tx;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (log.id) {
                            return [2 /*return*/];
                        }
                        log.idb = true;
                        log.id = this.getId();
                        log.measurementUnits = [];
                        log.start = new Date();
                        return [4 /*yield*/, this.idbContext()];
                    case 1:
                        db = _a.sent();
                        tx = db.transaction(TaskIDBService.dbLogsTable, 'readwrite');
                        return [4 /*yield*/, tx.objectStore(TaskIDBService.dbLogsTable).add(log, log.id)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, tx.done];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, log];
                }
            });
        });
    };
    TaskIDBService.dbTasks = 'tasks';
    TaskIDBService.dbLogsTable = 'logs';
    TaskIDBService.dbStopLogsTable = 'logs-stopped';
    TaskIDBService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TaskIDBService_Factory() { return new TaskIDBService(i0.ɵɵinject(i1.IdbService)); }, token: TaskIDBService, providedIn: "root" });
    return TaskIDBService;
}());
export { TaskIDBService };
